import { render, staticRenderFns } from "./ExpertiseTabsList.vue?vue&type=template&id=0725c0da&scoped=true"
import script from "./ExpertiseTabsList.vue?vue&type=script&lang=js"
export * from "./ExpertiseTabsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725c0da",
  null
  
)

export default component.exports